export enum WsConnections {
  NOTIFICATION = 'notification',
  ON_CONNECT = 'on-connect',
  SEND_NOTIFICATION = 'send-notification',
}
